var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Pie',{attrs:{"options":_vm.chartOptions,"data":_vm.chartData,"id":"chartId","css-classes":_vm.cssClasses,"styles":_vm.styles}})
}
var staticRenderFns = []

export { render, staticRenderFns }